import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp, Search, PackageX, Download } from 'lucide-react';
import orderServices from '../../services/order.service';
import areaServices from '../../services/area.service';
import { toast } from "react-toastify";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Paper,
  Checkbox,
  ListItemText,
} from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import OrderTable from "./OrderTable";
import moment from "moment";
import { useAuthStore } from '../../store/useAuthStore';
import ConfirmDialog from '../Dialog/ConfirmDialog';
import Datepicker from "react-tailwindcss-datepicker";

function OrderList() {
  const { user } = useAuthStore();
  const USER_ROLE = user?.userDataObj?.role;
  const zoneValue = [
    {value : 1, label : 'North'},
    {value : 2, label : 'East'},
    {value : 3, label : 'West'},
    {value : 4, label : 'South'},
  ];

  const statusOptions = [
    { value: 4, label: "Order Placed" },
    { value: 11, label: "Order Approved" },
    { value: 12, label: "Order Rejected" },
    { value: 13, label: "Order dispatched" },
    { value: 14, label: "Order Delivered" },
    { value: 17, label: "Ready for dispatch"},
    { value: 18, label: "Delivery confirmed"},
    { value: 19, label: "Order is on hold"},
    {value: 20, label: "Order Cancelled"},
  ];
  const PAGE_SIZE = 10; 
  const orderFilter = localStorage.getItem('orderFilter') ? JSON.parse(localStorage.getItem('orderFilter')) : {};
  const startDate = orderFilter?.dateValue?.startDate || new moment('2025-01-01').startOf('day');
  const endDate = orderFilter?.dateValue?.endDate || new moment().endOf('month');
  const dateOptions = [
    {label : 'Order Date', value : 'order_date'},
    {label : 'Delivery Date', value : 'delivered_confirm_date'},
    {label : 'Approved Date', value : 'approved_date'},
  ];
  const [value, setValue] = useState({startDate,endDate});
  const [isDeliveryModalOpen, setDeliveryModalOpen] = useState(false);
  const [isOrderDeleteModalOpen, setOrderDeleteModalOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [orderListData, setOrderListData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, seTotalCount] = useState(0);
  const [totalOrderCount, seTotalOrderCount] = useState(0);
  const [zonalManagers, setZonalManagers] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [statusCount, setStatusCount] = useState([]);
  const [filters, setFilters] = useState({
    order_id: orderFilter?.order_id || "",
    nameAndMobileSearch : orderFilter?.nameAndMobileSearch || "",
    lrnoAndInvoiceSearch: orderFilter?.lrnoAndInvoiceSearch || "",
    region_id : orderFilter?.region_id || "",
    zonal_manager: orderFilter?.zonal_manager || "",
    status: orderFilter?.status || [],
    state: orderFilter?.state || "",
    district: orderFilter?.district || "",
    date_type : orderFilter?.date_type || '',
    dateRange: {
      startDate: null,
      endDate: null
    },
  });

  const confirmDelivery = async() => {
    // console.log(`Delivery confirmed for order ${selectedOrderId}`);
    try {
      const body = {order_id : selectedOrderId,user_id : user?.userDataObj?.user_id};
      const response = await orderServices.confirmOrder(body);
      if (response.status) {
        toast.success('Order successfully marked as delivered.', {toastId: 'successMessageConfirmDelivery'});
        searchData();
      } else {
        toast.error(response.message || 'Failed to update orders status', {toastId: 'errorMessageConfirmDelivery'});
      }
    } catch (error) {
        toast.error(error.message || 'Failed to update orders status.', {toastId: 'errorMessageConfirmDelivery'});
    }finally{setDeliveryModalOpen(false);}
  };

  const deleteOrder = async() => {
    // console.log(`Delete  order ${selectedOrderId}`);
    try {
      const body = {order_id : selectedOrderId, user_id : user?.userDataObj?.user_id};
      
      const response = await orderServices.deleteOrder(body);
      if (response.status) {
        toast.success('Order rejected successfully.', {toastId: 'successMessageDeleteOrder'});
        searchData();
      } else {
        toast.error(response.message || 'Failed to delete orders', {toastId: 'errorMessageDeleteOrder'});
      }
    } catch (error) {
        toast.error(error.message || 'Failed to delete orders.', {toastId: 'errorMessageDeleteOrder'});
    }finally{setOrderDeleteModalOpen(false);}
  };

  const resetFilters = () => {
    setFilters({
      order_id: "",
      nameAndMobileSearch : "",
      lrnoAndInvoiceSearch: "",
      region_id: "all",
      zonal_manager: "all",
      status: [],
      state: "",
      district: "",
      date_type : '',
      dateRange: {
        startDate: null,
        endDate: null
      },
    });
    setValue({startDate,endDate});
    setCurrentPage(0);
    localStorage.removeItem('orderFilter');
  };

  const fetchOrders = async (params) => {
    setIsLoading(true);
    try {
      if (USER_ROLE != 4) params['user_id'] = user?.userDataObj?.user_id;
      const response = await orderServices.getOrderList(params);
      console.log('response', response);
      if (!response?.status) {
        toast.info('Request to fetch order list failed.');
        setOrderListData([]);
        seTotalOrderCount(0);
        seTotalCount(0);
        return;
      }
      
      console.log('response data', response.data);
      setOrderListData(response?.data);
      seTotalCount(response?.pagination?.totalPages);
      seTotalOrderCount(response?.totalCount);
      setStatusCount(response?.statusCount || []);
    } catch (error) {
      toast.error(error.message || 'Failed to fetch order list.', {toastId: 'errorMessageFetchOrderList'});
      setOrderListData([]);
      seTotalOrderCount(0);
      seTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchStateList = async () => {
    try {
      const response = await areaServices.getStateList();
      if (!response?.status) {
        toast.info('Request to fetch state list failed.');
        setStates([]);
        return;
      } 
      setStates(response?.data);
    } catch (error) {
      toast.error(error.message || 'Failed to fetch state list.', {toastId: 'errorMessageStateList'});
      setStates([]);
    }
  }
  const fetchDistrictList = async () => {
    try {
      const params = {
        state_id : filters.state
      }
      const response = await areaServices.getDistrictList(params);
      if (!response?.status) {
        setDistricts([]);
        return;
      }      
      // console.log(response.data);
      
      setDistricts(response?.data);
    } catch (error) {
      toast.error(error.message || 'Failed to fetch state list.', {toastId: 'errorMessageDistrictList'});
      setDistricts([]);
    }
  }

  const handleDownloadAdmin = async () => {
    setIsLoading(true);
          const res = await orderServices.orderDownloadAdmin({
            user_id: user?.userDataObj?.user_id,
            order_id : filters.order_id || '',
            mobile : (Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
            distributor_name : !(Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
            lrnoAndInvoiceSearch : filters.lrnoAndInvoiceSearch || '',
            region_id: (filters.region_id && filters.region_id !== "all") ? filters.region_id : "",
            zonal_manager_id: (filters.zonal_manager && filters.zonal_manager !== "all") ? filters.zonal_manager : "",
            status_id: filters.status || "",
            state_id: filters.state || "",
            district_id: filters.district || "",
            date_type : filters.date_type || '',
            ...(filters.date_type && {
              date_type : filters.date_type,
              start_date : new moment(value.startDate)?.format('YYYY-MM-DD'),
              end_date : new moment(value.endDate)?.format('YYYY-MM-DD'),
            })});
    
          if (res.status) {
              toast.success(res?.data?.data?.message, {toastId: 'successMessageDownloadAdmin'})
          } else if(res?.data?.statusText === 
            "Not Found") {
              toast.error('Data Not Found', {toastId: 'errorMessageDownloadAdmin'})
            } 
          else {
              toast.error('Failed to download', {toastId: 'errorMessageDownloadAdmin'})
          }
          setIsLoading(false);
  }

  const handleDownloadDist = async () => {
    setIsLoading(true);
          const res = await orderServices.orderDownloadDist({
            user_id: user?.userDataObj?.user_id,
            order_id : filters.order_id || '',
            mobile : (Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
            distributor_name : !(Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
            lrnoAndInvoiceSearch : filters.lrnoAndInvoiceSearch || '',
            region_id: (filters.region_id && filters.region_id !== "all") ? filters.region_id : "",
            zonal_manager_id: (filters.zonal_manager && filters.zonal_manager !== "all") ? filters.zonal_manager : "",
            status_id: filters.status || "",
            state_id: filters.state || "",
            district_id: filters.district || "",
            date_type : filters.date_type || '',
            ...(filters.date_type && {
              date_type : filters.date_type,
              start_date : new moment(value.startDate)?.format('YYYY-MM-DD'),
              end_date : new moment(value.endDate)?.format('YYYY-MM-DD'),
            })});
    
          if (res.status) {
              toast.success(res?.data?.data?.message, {toastId: 'successMessageDownloadDist'})
          } else if(res?.data?.statusText === 
            "Not Found") {
              toast.error('Data Not Found', {toastId: 'errorMessageDownloadDist'})
            } 
          else {
              toast.error('Failed to download', {toastId: 'errorMessageDownloadDist'})
          }
          setIsLoading(false);
  }

  const applyFilter = async () => {
    fetchOrders({
      order_id : filters.order_id || '',
      mobile : (Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
      distributor_name : !(Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
      lrnoAndInvoiceSearch : filters.lrnoAndInvoiceSearch || '',
      region_id: (filters.region_id && filters.region_id !== "all") ? filters.region_id : "",
      zonal_manager_id: (filters.zonal_manager && filters.zonal_manager !== "all") ? filters.zonal_manager : "",
      status_id: filters.status || "",
      state_id: filters.state || "",
      district_id: filters.district || "",
      date_type : filters.date_type || '',
      limit : PAGE_SIZE,
      offset : 1,
      ...(filters.date_type && {
        date_type : filters.date_type,
        start_date : new moment(value.startDate)?.format('YYYY-MM-DD'),
        end_date : new moment(value.endDate)?.format('YYYY-MM-DD'),
      })
    });
    setCurrentPage(1);
  }

  const searchData = async () => {
    fetchOrders({
      order_id : filters.order_id || '',
      mobile : (Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
      distributor_name : !(Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
      lrnoAndInvoiceSearch : filters.lrnoAndInvoiceSearch || '',
      region_id: (filters.region_id && filters.region_id !== "all") ? filters.region_id : "",
      zonal_manager_id: (filters.zonal_manager && filters.zonal_manager !== "all") ? filters.zonal_manager : "",
      status_id: filters.status || "",
      state_id: filters.state || "",
      district_id: filters.district || "",
      date_type : filters.date_type || '',
      limit : PAGE_SIZE,
      offset : currentPage,
      ...(filters.date_type && {
        date_type : filters.date_type,
        start_date : new moment(value.startDate)?.format('YYYY-MM-DD'),
        end_date : new moment(value.endDate)?.format('YYYY-MM-DD'),
      })
    });
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onSelectDate = async (value) => {
    if(!filters.date_type) return toast.info('Please select date type first.')
    setValue(value);
  };
  useEffect(() => {
    fetchOrders({
      order_id : filters.order_id || '',
      mobile : (Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
      distributor_name : !(Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
      lrnoAndInvoiceSearch : filters.lrnoAndInvoiceSearch || '',
      region_id: (filters.region_id && filters.region_id !== "all") ? filters.region_id : "",
      zonal_manager_id: (filters.zonal_manager && filters.zonal_manager !== "all") ? filters.zonal_manager : "",
      status_id: filters.status || "",
      state_id: filters.state || "",
      district_id: filters.district || "",
      date_type : filters.date_type || '',
      limit : PAGE_SIZE,
      offset : currentPage,
      ...(filters.date_type && {
        date_type : filters.date_type,
        start_date : new moment(value.startDate)?.format('YYYY-MM-DD'),
        end_date : new moment(value.endDate)?.format('YYYY-MM-DD'),
      })
    });
    fetchStateList();
  }, []);
  useEffect(() => {
      if (filters.state) {
        fetchDistrictList();
      }
  },[filters.state])
  useEffect(() => {
    fetchOrders({
      order_id : filters.order_id || '',
      mobile : (Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
      distributor_name : !(Number(filters.nameAndMobileSearch)) ?  filters.nameAndMobileSearch : '',
      lrnoAndInvoiceSearch : filters.lrnoAndInvoiceSearch || '',
      region_id: (filters.region_id && filters.region_id !== "all") ? filters.region_id : "",
      zonal_manager_id: (filters.zonal_manager && filters.zonal_manager !== "all") ? filters.zonal_manager : "",
      status_id: filters.status || "",
      state_id: filters.state || "",
      district_id: filters.district || "",
      date_type : filters.date_type || '',
      limit : PAGE_SIZE,
      offset : currentPage,
      ...(filters.date_type && {
        date_type : filters.date_type,
        start_date : new moment(value.startDate)?.format('YYYY-MM-DD'),
        end_date : new moment(value.endDate)?.format('YYYY-MM-DD'),
      })
    });
  }, [currentPage]);

  useEffect(() => {
    applyFilter();
  }, [
    // filters.nameAndMobileSearch,
    // filters.order_id,
    // filters.lrnoAndInvoiceSearch,
    filters.region_id,
    filters.zonal_manager,
    filters.state,
    filters.district,
    filters.status,
  ]);

  useEffect(() => {
    if (filters.date_type && value.startDate && value.endDate) {
      applyFilter();
    }
}, [filters.date_type, value.startDate, value.endDate]);

useEffect(() => {
  const fetchZonalManagers = async (id=null) => {
    try {
      const response = await orderServices.getZonalList(id);
      if (response.status) {
        setZonalManagers(response.data.map(item => ({value: item.user_id,label: item.firstName + " " + item.lastName})) || []);
      } else {
        setZonalManagers([]);
      }
    } catch (error) {
      toast.error(error.message || 'Failed to fetch zonal managers.', {toastId: 'errorMessageFetchZonalManagers'});
      setZonalManagers([]);
    }
  };
  if (filters.region_id && filters.region_id !== "all") {
    fetchZonalManagers(filters.region_id);
  } else {
    fetchZonalManagers();
  }
}, [filters.region_id])

const handleKeyPress = (e) => {
  if (e.key === 'Enter') {
    applyFilter();
  }
};

  return (
    <div className="p-2" style={{ overflow: 'visible' }}>
      {/* Filters & Summary Section */}
      <div className="mb-2" style={{ overflow: 'visible' }}>
        {
          USER_ROLE === 3 ? (
            <div className="flex justify-end items-center mb-4">
              <div className="flex gap-2 justify-end mb-2">
                <span className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg">
                  Total Orders: {totalOrderCount}
                </span>
              </div>
            </div>
          ) : (
            <div className="p-3 bg-white rounded-lg shadow">
              <div className="flex items-center gap-6 overflow-x-auto whitespace-nowrap py-1">
                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="28.8" height="28.8" rx="4.8" fill="#33B89D" />
                      <path d="M11.5615 14.1H14.6769M11.5615 16.5923H14.6769M11.5615 19.0846H14.6769M17.1692 19.7077H19.0384C19.5342 19.7077 20.0096 19.5108 20.3602 19.1602C20.7107 18.8097 20.9076 18.3342 20.9076 17.8385V9.20511C20.9076 8.26218 20.2056 7.46215 19.266 7.38406C18.9553 7.35829 18.6443 7.33614 18.3331 7.3176M18.3331 7.3176C18.3882 7.49629 18.4154 7.68223 18.4153 7.86923C18.4153 8.03448 18.3497 8.19296 18.2328 8.30981C18.116 8.42666 17.9575 8.49231 17.7923 8.49231H14.0538C13.7099 8.49231 13.4307 8.21317 13.4307 7.86923C13.4307 7.67732 13.4598 7.49206 13.5138 7.3176M18.3331 7.3176C18.098 6.55495 17.3868 6 16.5461 6H15.3C14.9006 6.00009 14.5117 6.12806 14.1903 6.36516C13.8688 6.60225 13.6318 6.93603 13.5138 7.3176M13.5138 7.3176C13.2014 7.33671 12.8907 7.35914 12.58 7.38406C11.6404 7.46215 10.9384 8.26218 10.9384 9.20511V10.9846M10.9384 10.9846H8.13457C7.61866 10.9846 7.19995 11.4033 7.19995 11.9192V21.2654C7.19995 21.7813 7.61866 22.2 8.13457 22.2H16.2346C16.7505 22.2 17.1692 21.7813 17.1692 21.2654V11.9192C17.1692 11.4033 16.7505 10.9846 16.2346 10.9846H10.9384ZM9.69226 14.1H9.6989V14.1066H9.69226V14.1ZM9.69226 16.5923H9.6989V16.599H9.69226V16.5923ZM9.69226 19.0846H9.6989V19.0913H9.69226V19.0846Z" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="font-medium">Total Orders Placed</span>
                  <span className="ml-1 font-semibold">{totalOrderCount}</span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="28.8" height="28.8" rx="4.8" fill="#33B89D" />
                      <path d="M20 15.8462V13.6923C20 12.9579 19.7155 12.2535 19.2092 11.7342C18.7028 11.2148 18.0161 10.9231 17.3 10.9231H16.1C15.8613 10.9231 15.6324 10.8258 15.4636 10.6527C15.2948 10.4796 15.2 10.2448 15.2 10V8.76923C15.2 8.03479 14.9155 7.33042 14.4092 6.81109C13.9028 6.29176 13.2161 6 12.5 6H11M12.8 13.3846H15.8M12.2 15.5385H15.8M14 19.5385L12.2 17.6923H12.5C13.057 17.6923 13.5911 17.4654 13.9849 17.0615C14.3788 16.6575 14.6 16.1097 14.6 15.5385C14.6 14.9672 14.3788 14.4194 13.9849 14.0155C13.5911 13.6115 13.057 13.3846 12.5 13.3846H12.2M12.8 6H8.9C8.4032 6 8 6.41354 8 6.92308V21.0769C8 21.5865 8.4032 22 8.9 22H19.1C19.5968 22 20 21.5865 20 21.0769V13.3846C20 11.4261 19.2414 9.54779 17.8912 8.1629C16.5409 6.77802 14.7096 6 12.8 6Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="font-medium">Total Order Value</span>
                  <span className="ml-1 font-semibold">
                    {`${Math.trunc(statusCount?.find(item => item.status_id === 4)?.total_amount) || 0}/-`}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="28.8" height="28.8" rx="4.8" fill="#33B89D" />
                      <path d="M14 15.6364L9.5 13.1818L5 15.6364M14 15.6364V20.5455M14 15.6364L9.5 18.0909M14 15.6364L18.5 13.1818L23 15.6364M14 15.6364L18.5 18.0909M14 20.5455L9.5 23M14 20.5455L18.5 23M9.5 23L5 20.5455V15.6364M9.5 23V18.0909M5 15.6364L9.5 18.0909M11.75 14.4091L7.25 16.8636M23 15.6364V20.5455L18.5 23M23 15.6364L18.5 18.0909M18.5 23V18.0909M20.75 14.4091L16.25 16.8636M18.3091 7.45455L13.9454 5L9.5818 7.45455M18.3091 7.45455V12.3636L13.9454 14.8182M18.3091 7.45455L13.9454 9.90909M13.9454 14.8182L9.5818 12.3636V7.45455M13.9454 14.8182V9.90909M9.5818 7.45455L13.9454 9.90909M16.1273 6.22727L11.7636 8.68182" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="font-medium">Total Ordered Sets</span>
                  <span className="ml-1 font-semibold">
                    {statusCount?.find(item => item.status_id === 4)?.Total_placed_order_sets || 0}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 4.8C0 2.14903 2.14903 0 4.8 0H24C26.651 0 28.8 2.14903 28.8 4.8V24C28.8 26.651 26.651 28.8 24 28.8H4.8C2.14903 28.8 0 26.651 0 24V4.8Z" fill="#33B89D" />
                      <path d="M21.4394 15.0626C21.6095 13.5692 21.3108 12.0599 20.5846 10.7439C19.8585 9.42783 18.7409 8.37031 17.3868 7.71789C16.0328 7.06548 14.5092 6.85049 13.0275 7.10272C11.5457 7.35496 10.1792 8.06193 9.11722 9.12563C8.05526 10.1893 7.35054 11.5571 7.10074 13.0392C6.85093 14.5214 7.06843 16.0445 7.72307 17.3975C8.37771 18.7505 9.43706 19.8664 10.7543 20.5904C12.0715 21.3143 13.5813 21.6106 15.0744 21.438" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M14.2417 10.218V14.2419L15.8512 15.8514" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M18.2656 18.269V22.2929" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M21.4875 18.269V22.2929" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="font-medium">Approval Pending</span>
                  <span className="ml-1 font-semibold">
                    {statusCount?.find(item => item.status_id === 4)?.count || 0}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 4.8C0 2.14903 2.14903 0 4.8 0H24C26.651 0 28.8 2.14903 28.8 4.8V24C28.8 26.651 26.651 28.8 24 28.8H4.8C2.14903 28.8 0 26.651 0 24V4.8Z" fill="#33B89D" />
                      <path d="M13.5138 7.3176C13.4598 7.49206 13.4307 7.67732 13.4307 7.86923C13.4307 8.21317 13.7099 8.49231 14.0538 8.49231H17.7923C17.9575 8.49231 18.116 8.42666 18.2328 8.30981C18.3497 8.19296 18.4153 8.03448 18.4153 7.86923C18.4154 7.68223 18.3874 7.49629 18.3323 7.3176M13.5138 7.3176C13.6318 6.93603 13.8688 6.60225 14.1903 6.36516C14.5117 6.12806 14.9006 6.00009 15.3 6H16.5461C17.3868 6 18.0972 6.55495 18.3323 7.3176M13.5138 7.3176C13.2014 7.33671 12.8907 7.35914 12.58 7.38406C11.6404 7.46215 10.9384 8.26218 10.9384 9.20511V10.9846M18.3323 7.3176C18.6446 7.33671 18.9553 7.35914 19.266 7.38406C20.2056 7.46215 20.9076 8.26218 20.9076 9.20511V17.8385C20.9076 18.3342 20.7107 18.8097 20.3602 19.1602C20.0096 19.5108 19.5342 19.7077 19.0384 19.7077H17.1692M10.9384 10.9846H8.13457C7.61866 10.9846 7.19995 11.4033 7.19995 11.9192V21.2654C7.19995 21.7813 7.61866 22.2 8.13457 22.2H16.2346C16.7505 22.2 17.1692 21.7813 17.1692 21.2654V19.7077M10.9384 10.9846H16.2346C16.7505 10.9846 17.1692 11.4033 17.1692 11.9192V19.7077M10.3153 17.2154L11.5615 18.4615L14.0538 15.3462" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="font-medium">Approved Orders</span>
                  <span className="ml-1 font-semibold">
                    {statusCount?.find(item => item.status_id === 11)?.count || 0}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="28.8" height="28.8" rx="4.8" fill="#33B89D" />
                      <path d="M20 15.8462V13.6923C20 12.9579 19.7155 12.2535 19.2092 11.7342C18.7028 11.2148 18.0161 10.9231 17.3 10.9231H16.1C15.8613 10.9231 15.6324 10.8258 15.4636 10.6527C15.2948 10.4796 15.2 10.2448 15.2 10V8.76923C15.2 8.03479 14.9155 7.33042 14.4092 6.81109C13.9028 6.29176 13.2161 6 12.5 6H11M12.8 13.3846H15.8M12.2 15.5385H15.8M14 19.5385L12.2 17.6923H12.5C13.057 17.6923 13.5911 17.4654 13.9849 17.0615C14.3788 16.6575 14.6 16.1097 14.6 15.5385C14.6 14.9672 14.3788 14.4194 13.9849 14.0155C13.5911 13.6115 13.057 13.3846 12.5 13.3846H12.2M12.8 6H8.9C8.4032 6 8 6.41354 8 6.92308V21.0769C8 21.5865 8.4032 22 8.9 22H19.1C19.5968 22 20 21.5865 20 21.0769V13.3846C20 11.4261 19.2414 9.54779 17.8912 8.1629C16.5409 6.77802 14.7096 6 12.8 6Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="font-medium">Approved Order value</span>
                  <span className="ml-1 font-semibold">
                    {`${Math.trunc(statusCount?.find(item => item.status_id === 11)?.total_amount) || 0}/-`}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="28.8" height="28.8" rx="4.8" fill="#33B89D" />
                      <path d="M14 15.6364L9.5 13.1818L5 15.6364M14 15.6364V20.5455M14 15.6364L9.5 18.0909M14 15.6364L18.5 13.1818L23 15.6364M14 15.6364L18.5 18.0909M14 20.5455L9.5 23M14 20.5455L18.5 23M9.5 23L5 20.5455V15.6364M9.5 23V18.0909M5 15.6364L9.5 18.0909M11.75 14.4091L7.25 16.8636M23 15.6364V20.5455L18.5 23M23 15.6364L18.5 18.0909M18.5 23V18.0909M20.75 14.4091L16.25 16.8636M18.3091 7.45455L13.9454 5L9.5818 7.45455M18.3091 7.45455V12.3636L13.9454 14.8182M18.3091 7.45455L13.9454 9.90909M13.9454 14.8182L9.5818 12.3636V7.45455M13.9454 14.8182V9.90909M9.5818 7.45455L13.9454 9.90909M16.1273 6.22727L11.7636 8.68182" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="font-medium">Approved Order sets</span>
                  <span className="ml-1 font-semibold">
                    {statusCount?.find(item => item.status_id === 11)?.Total_approved_order_sets || 0}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 4.8C0 2.14903 2.14903 0 4.8 0H24C26.651 0 28.8 2.14903 28.8 4.8V24C28.8 26.651 26.651 28.8 24 28.8H4.8C2.14903 28.8 0 26.651 0 24V4.8Z" fill="#33B89D" />
                      <path d="M11.5836 8.3999H10.1142C9.65953 8.3999 9.2235 8.58954 8.902 8.92711C8.58051 9.26468 8.3999 9.72251 8.3999 10.1999V20.9999C8.3999 21.4773 8.58051 21.9351 8.902 22.2727C9.2235 22.6103 9.65953 22.7999 10.1142 22.7999H18.6856C19.1403 22.7999 19.5763 22.6103 19.8978 22.2727C20.2193 21.9351 20.3999 21.4773 20.3999 20.9999V10.1999C20.3999 9.72251 20.2193 9.26468 19.8978 8.92711C19.5763 8.58954 19.1403 8.3999 18.6856 8.3999H17.121" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M12.1 9.05005H16.7C16.8657 9.05005 17 8.91573 17 8.75005V8.55005C17 7.44548 16.1046 6.55005 15 6.55005H13.8C12.6955 6.55005 11.8 7.44548 11.8 8.55005V8.75005C11.8 8.91573 11.9344 9.05005 12.1 9.05005Z" stroke="white" />
                      <path d="M12.4797 18.5999L16.6797 14.3999M12.4797 14.3999L16.6797 18.5999" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="font-medium">Rejected Orders</span>
                  <span className="ml-1 font-semibold">
                    {statusCount?.find(item => item.status_id === 12)?.count || 0}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 4.8C0 2.14903 2.14903 0 4.8 0H24C26.651 0 28.8 2.14903 28.8 4.8V24C28.8 26.651 26.651 28.8 24 28.8H4.8C2.14903 28.8 0 26.651 0 24V4.8Z" fill="#33B89D" />
                      <g clipPath="url(#clip0_1095_2360)">
                        <path d="M14.9403 22.4802H8.78026C8.31386 22.4802 7.86594 22.2945 7.53594 21.9645C7.20594 21.6345 7.02026 21.1866 7.02026 20.7202V11.9202C7.02026 11.4538 7.20594 11.0058 7.53594 10.6758C7.86594 10.3458 8.31386 10.1602 8.78026 10.1602H10.5403M21.1003 12.9058V11.9202C21.1003 11.4538 20.9146 11.0058 20.5846 10.6758C20.2546 10.3458 19.8067 10.1602 19.3403 10.1602H17.5803" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M17.5802 12.8V7.52001C17.5802 7.05361 17.3945 6.60569 17.0645 6.27569C16.7345 5.94569 16.2866 5.76001 15.8202 5.76001H12.3002C11.8338 5.76001 11.3858 5.94569 11.0558 6.27569C10.7258 6.60569 10.5402 7.05361 10.5402 7.52001V12.8M17.5802 12.8H10.5402M17.5802 12.8H18.4602M10.5402 12.8H9.66016" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.54 16.3201V16.3281" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.54 18.96V18.968" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14.0601 16.3113V16.3193" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14.0601 18.96V18.968" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M22.7497 16.1919H17.708H19.083C19.5692 16.1919 20.0356 16.385 20.3794 16.7289C20.7232 17.0727 20.9163 17.539 20.9163 18.0252C20.9163 18.5115 20.7232 18.9778 20.3794 19.3216C20.0356 19.6654 19.5692 19.8586 19.083 19.8586H17.708L20.458 22.6086" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M17.708 18.0249H22.7497" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1095_2360">
                          <rect width="21.12" height="21.12" fill="white" transform="translate(3.5 4)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span className="font-medium">Dispatched Orders</span>
                  <span className="ml-1 font-semibold">
                    {statusCount?.find(item => item.status_id === 13)?.count || 0}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded bg-emerald-500 text-white">
                    <svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 4.8C0 2.14903 2.14903 0 4.8 0H24C26.651 0 28.8 2.14903 28.8 4.8V24C28.8 26.651 26.651 28.8 24 28.8H4.8C2.14903 28.8 0 26.651 0 24V4.8Z" fill="#33B89D" />
                      <path d="M11.5 8.3999H10.1142C9.65953 8.3999 9.2235 8.58954 8.902 8.92711C8.58051 9.26468 8.3999 9.72251 8.3999 10.1999V20.9999C8.3999 21.4773 8.58051 21.9351 8.902 22.2727C9.2235 22.6103 9.65953 22.7999 10.1142 22.7999H18.6856C19.1403 22.7999 19.5763 22.6103 19.8978 22.2727C20.2193 21.9351 20.3999 21.4773 20.3999 20.9999V10.1999C20.3999 9.72251 20.2193 9.26468 19.8978 8.92711C19.5763 8.58954 19.1403 8.3999 18.6856 8.3999H17.2357" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M12.1 9.05005H16.7C16.8657 9.05005 17 8.91573 17 8.75005V8.55005C17 7.44548 16.1046 6.55005 15 6.55005H13.8C12.6955 6.55005 11.8 7.44548 11.8 8.55005V8.75005C11.8 8.91573 11.9344 9.05005 12.1 9.05005Z" stroke="white" />
                      <path d="M14.7998 17.6H13.9998C12.6166 17.6 11.4156 18.38 10.8128 19.5242C10.8042 19.4173 10.7998 19.3091 10.7998 19.2C10.7998 16.9908 12.5907 15.2 14.7998 15.2V13.2L18.7998 16.4L14.7998 19.6V17.6Z" fill="white" />
                    </svg>
                  </span>
                  <span className="font-medium">Delivery confirmed</span>
                  <span className="ml-1 font-semibold">
                    {statusCount?.find(item => item.status_id === 18)?.count || 0}
                  </span>
                </div>
              </div>
            </div>
          )
        }

        {/* Filters - single line, always visible. position+zIndex so datepicker popup appears above table; overflow visible so popup isn't clipped */}
        <div className="mt-2 p-2 bg-white rounded-lg shadow flex flex-nowrap items-center gap-1.5" style={{ position: 'relative', zIndex: 30, overflow: 'visible' }}>
          {(USER_ROLE === 4) && (
            <FormControl size="small" sx={{ minWidth: 80 }}>
              <InputLabel>Zone</InputLabel>
              <Select
                value={filters.region_id}
                label="Zone"
                onChange={(e) =>
                  setFilters({ ...filters, region_id: e.target.value })
                }
                disabled={filters.zonal_manager !== "" && filters.zonal_manager !== "all"}
              >
                <MenuItem value="all">Zones</MenuItem>
                {zoneValue?.map((zone) => (
                  <MenuItem key={zone.value} value={zone.value}>
                    {zone.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {(USER_ROLE === 4) && (
            <FormControl size="small" sx={{ minWidth: 90 }}>
              <InputLabel>ZM</InputLabel>
              <Select
                value={filters.zonal_manager}
                label="Zonal Manager"
                onChange={(e) =>
                  setFilters({ ...filters, zonal_manager: e.target.value })
                }
              >
                <MenuItem value="all">All Zonal Managers</MenuItem>
                {zonalManagers?.map((manager) => (
                  <MenuItem key={manager.value} value={manager.value}>
                    {manager.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {(USER_ROLE === 4 || USER_ROLE === 5) && (
            <TextField
              label="Dist name/mobile"
              variant="outlined"
              value={filters.nameAndMobileSearch}
              onKeyUp={handleKeyPress}
              onChange={(e) =>
                setFilters({ ...filters, nameAndMobileSearch: e.target.value })
              }
              placeholder="Name or mobile"
              size="small"
              sx={{ minWidth: 140 }}
            />
          )}
          <TextField
            label="LR/Invoice No."
            variant="outlined"
            value={filters.lrnoAndInvoiceSearch}
            onKeyUp={handleKeyPress}
            onChange={(e) =>
              setFilters({ ...filters, lrnoAndInvoiceSearch: e.target.value })
            }
            placeholder="LR or Invoice"
            size="small"
            sx={{ minWidth: 120 }}
          />
          {(USER_ROLE === 4 || USER_ROLE === 5) && (
            <FormControl size="small" sx={{ minWidth: 80 }}>
              <InputLabel>State</InputLabel>
              <Select
                value={filters.state}
                label="State"
                onChange={async (e) => {
                  setFilters({
                    ...filters,
                    state: e.target.value,
                    district: "",
                  });
                }}
              >
                <MenuItem value=""><em>All State</em></MenuItem>
                {states.map((state) => (
                  <MenuItem key={state?.state_id} value={state?.state_id}>
                    {state?.state_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {(USER_ROLE === 4 || USER_ROLE === 5) && (
            <FormControl size="small" sx={{ minWidth: 90 }}>
              <InputLabel>District</InputLabel>
              <Select
                value={filters.district}
                label="District"
                onChange={(e) =>
                  setFilters({ ...filters, district: e.target.value })
                }
                disabled={!filters.state}
              >
                <MenuItem value=""><em>All District</em></MenuItem>
                {districts.map((district) => (
                  <MenuItem key={district?.id} value={district?.id}>
                    {district?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <TextField
            label="Order id"
            variant="outlined"
            value={filters.order_id}
            onKeyUp={handleKeyPress}
            onChange={(e) =>
              setFilters({ ...filters, order_id: e.target.value })
            }
            placeholder="Order id"
            size="small"
            sx={{ minWidth: 90 }}
          />
          <FormControl size="small" sx={{ minWidth: 110 }}>
            <InputLabel>Date type</InputLabel>
            <Select
              value={filters.date_type}
              label="Date type"
              onChange={(e) =>
                setFilters({ ...filters, date_type: e.target.value })
              }
            >
              <MenuItem value=""><em>Date Type</em></MenuItem>
              {dateOptions?.map((zone) => (
                <MenuItem key={zone.value} value={zone.value}>
                  {zone.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div style={{ position: 'relative', zIndex: 50, overflow: 'visible', minWidth: '180px', flex: '0 0 auto' }}>
            <Datepicker
              displayFormat="DD/MM/YYYY"
              primaryColor={"emerald"}
              minDate={new Date("2025-01-01")}
              value={value}
              onChange={(newValue) => onSelectDate(newValue)}
              showShortcuts={true}
              popoverDirection="down"
              containerClassName="relative w-full"
              inputClassName="w-full min-w-[180px] border border-gray-300 rounded-md px-3 py-2 h-[40px] bg-white hover:border-gray-400 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none text-xs"
            />
          </div>
          <FormControl size="small" sx={{ minWidth: 90 }}>
            <InputLabel>Status</InputLabel>
            <Select
              multiple
              value={filters.status}
              label="Status"
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
              renderValue={(selected) =>
                selected
                  .map((v) =>
                    statusOptions.find((o) => o.value === v)?.label
                  )
                  .join(", ")
              }
              MenuProps={{
                PaperProps: { style: { maxHeight: 224 } },
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Checkbox
                    checked={filters.status.indexOf(option.value) > -1}
                  />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <button
            onClick={resetFilters}
            className="flex-shrink-0 px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50"
          >
            Reset
          </button>
          <button
            onClick={() =>
              (USER_ROLE === 4 || USER_ROLE === 5)
                ? handleDownloadAdmin()
                : handleDownloadDist()
            }
            className="flex-shrink-0 inline-flex items-center px-3 py-2 text-sm font-medium text-emerald-600 bg-emerald-100 rounded-md hover:bg-emerald-200"
          >
            <Download className="mr-1.5 h-3 w-3" />
          </button>
        </div>
      </div>

      {/* Orders List Table*/}
      <OrderTable
        isLoading={isLoading}
        orderListData={orderListData}
        setSelectedOrderId={setSelectedOrderId}
        setDeliveryModalOpen={setDeliveryModalOpen}
        setOrderDeleteModalOpen={setOrderDeleteModalOpen}
        totalPage={totalCount}
        pageNumber={currentPage}
        handlePageChange={handlePageChange}
        searchData={searchData}
        filters={{...filters, dateValue : value}}
      />

      {/* Delivery Confirmation Modal */}
      <ConfirmDialog
        isOpen={isDeliveryModalOpen}
        setIsOpen={setDeliveryModalOpen}
        handler={confirmDelivery}
        title="Confirmation"
        message="Are you sure you want to mark this order as delivered?"
      />

      <ConfirmDialog
        isOpen={isOrderDeleteModalOpen}
        setIsOpen={setOrderDeleteModalOpen}
        handler={deleteOrder}
        title="Confirmation"
        message="Are you sure you want to delete this order?"
        color="red"
      />
    </div>
  );
}

export default OrderList;